import { IsBoolean, IsNotEmpty } from 'class-validator'

export class PatchMissionTicketPrintedDto {
  @IsBoolean()
  @IsNotEmpty()
  isPrinted!: boolean
}
